import React, { useEffect, useState } from "react";
import firebase from "../../firebase/firebase";
import icon from "../../assets/googleLogo.png";
import styling from "./Login.module.css";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import loginImage from "../../assets/signInPage.svg";
import Navbar from "../Home/Navbar/Navbar";

function Login() {
  let isLogged = useSelector((state) => state.isLogged);
  let shopDetails = useSelector((state) => state.shopDetails);

  // console.log("SHOP DETAILS", shopDetails);
  if (isLogged && shopDetails.shopName) {
    return <Redirect to="/dashboard" />;
  } else if (isLogged && !shopDetails.shopName) {
    return <Redirect to="/registerOptions" />;
  }

  let loginWithGoogle = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        var user = result.user;
        const db = firebase.firestore();
        db.collection("users")
          .doc(user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              console.log("User is already registered", doc.data());
            } else {
              db.collection("users")
                .doc(user.uid)
                .set({
                  name: user.displayName,
                  email: user.email,
                  photo: user.photoURL,
                  id: user.uid,
                })
                .then((docRef) => {
                  console.log("Welcome new user");
                })
                .catch((error) => {
                  console.error("Error adding document: ", error);
                });
            }
          })
          .catch(() => {
            console.log("Error");
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div className={styling.logInPageParent}>
      <Navbar hideLogin={true} />

      <div className={styling.logInPage}>
        <div className={styling.logInPageText}>
          <img src={loginImage} alt="login" />
        </div>
        <div className={styling.logInPageActualSignIn}>
          <h2>A smarter way to manage your shop</h2>
          <p className={styling.trustText}>Secure • Fast • Powered by Google</p>
          <div className={styling.googleSignIn} onClick={loginWithGoogle}>
            <img src={icon} alt="logo" />
            <p>Sign in with Google</p>
          </div>
          <p>
            Our management software is an inventory management platform designed
            to solve the everyday challenges that shopkeepers and their
            customers face.
          </p>
          <p>Relax, it’s free forever</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
